export default class ErrorUtil {
	static getErrorMessage(rawError) {
		if (!rawError.response) {
			return rawError;
		}
		const error = rawError.response.data;

		if (error.errors) {
			return error.errors[0].defaultMessage;
		} else if(error.message) {
			return error.message;
		} else {
			return error;
		}
	}
}